module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/image/image.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/image/image.png
// module id = 579
// module chunks = 0